module.exports = __webpack_public_path__ + "static/forecast/temperature/cold-faa322958cc802528340fcbf36b83137.svg";